import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { EmpresaService } from '@shared/service/app/empresa.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-grid-filter',
  templateUrl: './grid-filter.component.html',
  styleUrls: ['./grid-filter.component.scss']
})
export class GridFilterComponent implements OnInit, OnDestroy {
  filter: string = '';
  color_primario: string = '';

  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private _empresaService: EmpresaService) {}

  ngOnInit(): void {
    this._empresaService.empresa$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((empresa) => {
        this.color_primario = empresa.color_primario;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }


  /**
  * Filtro para buscar en la grilla
  * @param filterValue 
  */
  applyFilter(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.filter = input.value.trim().toLowerCase();
    this.filterChange.emit(this.filter);
  }

  /**
  * Borra el filtro y emite un valor vacío para resetear la tabla
  */
  resetFilter() {
    this.filter = '';
    this.filterChange.emit('');
  }

}
